import {
	Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges, OnInit, ChangeDetectorRef
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NavigationService } from '../../../netview';
import { MessageService } from 'base';
import { DiscResultsService } from 'discovery';
import { Device } from 'DiscoveryEngine.TS/Core';
import { List, ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { IdentityService } from 'identity';
import {
	DisplayDeviceListEntryDto, GetDeviceResultDto
} from 'UvExplorerServer.Dtos.TS/Session';
import {
	InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';

@Component({
	selector: 'layer2-trace',
	templateUrl: './layer2-trace.component.html',
	styleUrls: ['./layer2-trace.component.scss']
})
export class Layer2TraceComponent implements OnChanges, OnDestroy, OnInit {

	@Input() public deviceGuid: string;
	@Input() public deviceGuid2: string;

	@Input()
	public ifTableHeightVh: number;

	@Input()
	public ifTableHeightPx: number;

	@Input()
	public ifTableMinHeight: number;

	@Input()
	public visible: boolean;

	@Input()
	public visible2: boolean;

	public device: Device;
	public deviceName: string;
	public displayDeviceSelector: boolean;

	public device2: Device;
	public deviceName2: string;
	public displayDeviceSelector2: boolean;

	public entries: any[];

	public selectedReport: string;
	public selectedReportInfo: InfoSetView;

	constructor(private formBuilder: UntypedFormBuilder,
		private navService: NavigationService,
		private messageService: MessageService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private changeDetector: ChangeDetectorRef,
		private changeDetector2: ChangeDetectorRef
	) {
		this.setDevice(null);
		this.displayDeviceSelector = false;

		this.setDevice2(null);
		this.displayDeviceSelector2 = false;

		this.entries = [];

		this.selectedReport = "";
		this.selectedReportInfo = this.emptyInfoSetView();
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (!!changes["deviceGuid"] || !!changes["visible"]) {
			if (!!this.deviceGuid && this.visible) {
				this.getDevice();
			}
			else {
				this.setDevice(null);
			}
		}

		if (!!changes["deviceGuid2"] || !!changes["visible2"]) {
			if (!!this.deviceGuid2 && this.visible2) {
				this.getDevice2();
			}
			else {
				this.setDevice2(null);
			}
		}
	}

	public ngOnInit(): void {
		//this.rebuildEntries();
	}

	public ngOnDestroy(): void {
	}

	private getLayer2Trace(): void {
		this.rebuildEntries();
	}

	private rebuildEntries(): void {
		// Initialize entries
		this.entries = [];

		// Build entries
		let tmp_entries = [];

		this.selectedReportInfo.entries.forEach((viewEntry: InfoSetViewEntry) => {
				let entry = {};

				for (let i = 0; i < viewEntry.values.length; ++i) {
					let col = this.selectedReportInfo.columns[i];
					let cell = viewEntry.values[i];

					// Initialize value property
					entry[col.field] = cell.value;
				}
				tmp_entries.push(entry);
			}
		);

		tmp_entries.forEach((entry:any[]) => {
				this.addEntry(entry["device"], entry["ipAddress"], entry["ifName"])
			}
		);
	}

	private addEntry(deviceName:string, ipAddress:string, ifName:string): void {
		let entry = {
			device:deviceName,
			ipaddress:ipAddress,
			interface:ifName
		};
		this.entries.push(entry);
	}

	public get enableSelectDevice(): boolean {
		return true;
	}

	public get enableSelectDevice2(): boolean {
		return true;
	}

	public selectDevice(): void {
		this.displayDeviceSelector = true;
	}

	private setDevice(device: Device): void {
		if (device) {
			this.device = device;
			this.deviceName = device.DisplayName;
		}
		else {
			this.device = null;
			this.deviceName = "Select a device";
		}
	}

	public onDeviceSelectorOk(devices: DisplayDeviceListEntryDto[]): void {
		this.deviceGuid = devices[0].deviceGuid;
		this.getDevice();
	}

	public onDeviceSelectorCancel(): void {
		this.displayDeviceSelector = false;
	}

	public selectDevice2(): void {
		this.displayDeviceSelector2 = true;
	}

	private setDevice2(device: Device): void {
		if (device) {
			this.device2 = device;
			this.deviceName2 = device.DisplayName;
		}
		else {
			this.device2 = null;
			this.deviceName2 = "Select a device";
		}
	}

	public onDeviceSelectorOk2(devices: DisplayDeviceListEntryDto[]): void {
		this.deviceGuid2 = devices[0].deviceGuid;
		this.getDevice2();
	}

	public onDeviceSelectorCancel2(): void {
		this.displayDeviceSelector2 = false;
	}

	private getDevice(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		let deviceGuids = new List<string>();
		deviceGuids.Add(this.deviceGuid);

		this.discResultsService.getDevice(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, "network", deviceGuids, true).subscribe(
				(result: GetDeviceResultDto) => {
					if (result.HasDevices) {
						this.setDevice(result.Devices.Get(0));
						this.changeDetector.detectChanges();
					}
					else {
						this.messageService.displayErrorMessage("Could not retrieve selected device");
					}
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve selected device");
				});
	}

	private getDevice2(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		let deviceGuids = new List<string>();
		deviceGuids.Add(this.deviceGuid2);

		this.discResultsService.getDevice(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, "network", deviceGuids, true).subscribe(
				(result: GetDeviceResultDto) => {
					if (result.HasDevices) {
						this.setDevice2(result.Devices.Get(0));
						this.changeDetector.detectChanges();
					}
					else {
						this.messageService.displayErrorMessage("Could not retrieve selected device");
					}
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve selected device");
				});

		deviceGuids.Clear();
		deviceGuids.Add(this.deviceGuid);
		deviceGuids.Add(this.deviceGuid2);

		this.discResultsService.getLayer2Trace(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, "network", deviceGuids, true).subscribe(
				(result: InfoSetView) => {
					// TODO:
					this.selectedReport = result.title;
					this.selectedReportInfo = result;
					this.rebuildEntries();

					this.changeDetector.markForCheck();
					this.changeDetector.detectChanges();
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve the selected report");
				});
	}

	private emptyInfoSetView(): InfoSetView {
		return {
			infoSetName: "",
			title: "",
			columns: [],
			entries: []
		};
	}

}
